export default "__VITE_ASSET__C1FB4UXb__"